import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16.122 16.243a.96.96 0 0 1-.96.96h-8.64a.96.96 0 0 1 0-1.92h8.64a.96.96 0 0 1 .96.96m-9.6-6.72h16.32a.96.96 0 0 0 0-1.92H6.522a.96.96 0 1 0 0 1.92m6.72 13.44h-6.72a.96.96 0 1 0 0 1.92h6.72a.96.96 0 0 0 0-1.92m15.08-2.598a.96.96 0 0 0-1.358 0l-3.162 3.162v-9.203a.96.96 0 1 0-1.92 0v9.203l-3.16-3.162a.96.96 0 0 0-1.358 1.358l4.8 4.8a.96.96 0 0 0 1.358 0l4.8-4.8a.96.96 0 0 0 0-1.358"
    />
  </svg>
);
const SvgIconSortAscending = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconSortAscending);
export default Memo;
